import React from 'react';
import { ArrowLeft, Heart, Users, Shield, Quote, Target } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { logoUrl } from '../mockData';

const Mission = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#1B2380] hover:text-[#0E8C84] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#1B2380] via-[#0E8C84] to-[#0E8C84] text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6">
            <Target className="text-white" size={40} />
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">
            La Nostra Mission
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Assicuriamo il valore di chi si prende cura degli altri
          </p>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 -mt-16 relative z-10">
          
          {/* Main Quote */}
          <div className="text-center mb-12">
            <Quote className="text-[#8FE3DA] mx-auto mb-6" size={48} />
            <blockquote className="text-xl sm:text-2xl text-gray-700 leading-relaxed italic">
              "In <strong className="text-[#1B2380]">Assietica Società Cooperativa Società Benefit</strong>, 
              la protezione non è un semplice contratto, ma un <strong className="text-[#0E8C84]">impegno verso la comunità</strong>."
            </blockquote>
          </div>

          {/* Founders Section */}
          <div className="bg-gradient-to-r from-[#1B2380]/5 to-[#0E8C84]/5 rounded-xl p-8 mb-10 border border-[#1B2380]/10">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-12 h-12 bg-[#8FE3DA]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <Heart className="text-[#E67E22]" size={24} />
              </div>
              <div>
                <h2 className="text-xl font-bold text-[#1B2380] mb-2">Le nostre radici</h2>
                <p className="text-gray-700 leading-relaxed">
                  Nasciamo dall'esperienza di oltre <strong>35 anni</strong> dei nostri fondatori, 
                  <strong className="text-[#1B2380]"> Umberto Cossu</strong> e <strong className="text-[#0E8C84]">Mauro Antonio Mura</strong>, 
                  attivi da decenni nel volontariato, nel soccorso e nel sostegno alle persone con disabilità.
                </p>
              </div>
            </div>
            
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                <div className="w-16 h-16 rounded-full overflow-hidden mx-auto mb-3 border-2 border-[#1B2380]/20">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_03ee4f26-8936-402f-baec-16aca96234af/artifacts/dukhogve_WhatsApp%20Image%202026-02-26%20at%2018.25.38.jpeg" 
                    alt="Umberto Cossu"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="font-bold text-center text-[#1B2380]">Umberto Cossu</h3>
                <p className="text-gray-500 text-center text-sm">Soccorso sanitario e assistenza tecnico sportiva</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                <div className="w-16 h-16 rounded-full overflow-hidden mx-auto mb-3 border-2 border-[#0E8C84]/20">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_03ee4f26-8936-402f-baec-16aca96234af/artifacts/ta3cssnp_WhatsApp%20Image%202026-02-26%20at%2018.22.20.jpeg" 
                    alt="Mauro Antonio Mura"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="font-bold text-center text-[#0E8C84]">Mauro Antonio Mura</h3>
                <p className="text-gray-500 text-center text-sm">Disabilità intellettiva</p>
              </div>
            </div>
          </div>

          {/* Identity Section */}
          <div className="mb-10">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Questa radice profonda ci definisce: siamo una <strong className="text-[#0E8C84]">Cooperativa</strong> che 
              crede nella mutualità e una <strong className="text-[#1B2380]">Società Benefit</strong> che persegue il bene comune.
            </p>
            
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-[#0E8C84]/5 rounded-xl p-6 border-l-4 border-[#0E8C84]">
                <div className="flex items-center space-x-3 mb-3">
                  <Users className="text-[#0E8C84]" size={24} />
                  <h3 className="font-bold text-[#0E8C84]">Cooperativa</h3>
                </div>
                <p className="text-gray-600 text-sm">Crediamo nella mutualità e nella partecipazione democratica</p>
              </div>
              <div className="bg-[#1B2380]/5 rounded-xl p-6 border-l-4 border-[#1B2380]">
                <div className="flex items-center space-x-3 mb-3">
                  <Shield className="text-[#1B2380]" size={24} />
                  <h3 className="font-bold text-[#1B2380]">Società Benefit</h3>
                </div>
                <p className="text-gray-600 text-sm">Perseguiamo il bene comune come obiettivo statutario</p>
              </div>
            </div>
          </div>

          {/* Mission Statement */}
          <div className="bg-gradient-to-r from-[#1B2380] to-[#0E8C84] rounded-xl p-8 text-white mb-10">
            <h2 className="text-2xl font-bold mb-4 text-center">La nostra missione</h2>
            <p className="text-lg text-white/95 leading-relaxed text-center">
              Offrire al <strong>Terzo Settore</strong>, alle <strong>Cooperative Sociali</strong> e 
              ai <strong>cittadini</strong> una consulenza assicurativa <em>etica, trasparente e umana</em>, 
              perché sappiamo bene che dietro ogni polizza ci sono <strong>persone, sogni e progetti da difendere</strong>.
            </p>
          </div>

          {/* Final Quote */}
          <div className="text-center bg-[#8FE3DA]/10 rounded-xl p-8 border border-[#8FE3DA]/20">
            <p className="text-2xl sm:text-3xl font-bold text-[#1B2380] leading-relaxed">
              "Assicuriamo il valore di chi si prende cura degli altri."
            </p>
          </div>

          {/* Navigation Buttons */}
          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-[#1B2380] to-[#0E8C84] text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              Torna alla Home
            </button>
            <Link
              to="/societa-benefit"
              className="bg-white text-[#1B2380] border-2 border-[#1B2380] px-8 py-3 rounded-lg font-semibold hover:bg-[#1B2380]/5 transition-all duration-300"
            >
              Identità Benefit
            </Link>
            <Link
              to="/societa-cooperativa"
              className="bg-white text-[#0E8C84] border-2 border-[#0E8C84] px-8 py-3 rounded-lg font-semibold hover:bg-[#0E8C84]/5 transition-all duration-300"
            >
              Anima Cooperativa
            </Link>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#10154F] text-white py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Società Cooperativa. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Mission;
